import { Component, OnInit } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { ModalService } from '@app/core/services/modal.service';
import { StateService } from '@app/core/services/state.service';
import { VtsService, VtsSetting } from '@app/services/vts.service';

@Component({ selector: 'tt-vts', templateUrl: './vts.component.html', styleUrls: ['./vts.component.css'], standalone: false })
export class VtsComponent implements OnInit {
    public page?: VtsSetting;
    public grid?: GridOptions;
    public gridVtLang?: GridOptions;
    public gridVtLink?: GridOptions;

    constructor(private service: VtsService, private state: StateService, private modal: ModalService) {}

    public async importVtFromDisc(): Promise<void> {
        const response = (await this.service.importVtFromDisc())[0];
        if (response.errorcode !== '0') {
            await this.modal.show({ type: 'danger', title: 'Varsel', message: response.errormessage, buttons: [{ label: 'OK', cssClass: 'btn-danger', close: true }] });
        }
        this.grid?.gridfunc?.read();
    }

    public selectVt(data: { data?: { clickedCell?: { dataItem?: { vt_keyno?: string } } } }): void {
        const key = data.data?.clickedCell?.dataItem?.vt_keyno;
        if (!key || !this.page) return;
        this.page.vt_keyno = key;
        this.gridVtLang?.gridfunc?.read();
        this.gridVtLink?.gridfunc?.read();
    }

    private configureChildGrids(): void {
        if (this.gridVtLang && this.gridVtLink) return;
        const params = () => ({ vt_keyno: this.page?.vt_keyno ?? '' });
        this.gridVtLang = new Grid().setRememberId('w_vts_vtlang_grid').setLoadDataFunction({ method: 3787, parameters: params }).setKendoConfig({ height: null, sortable: true, aggregate: true, pager: false, pageable: false, selectable: false, filterable: false });
        this.gridVtLink = new Grid().setRememberId('w_vts_vtlink_grid').setLoadDataFunction({ method: 3788, parameters: params }).setKendoConfig({ height: null, sortable: true, aggregate: true, pager: false, pageable: false, selectable: false, filterable: false }).setCustomToolbarButtons([{
            name: 'vtlink_new', text: 'vtlink_new', icon: 'fa-plus', cssClass: 'btn btn-primary im-grid-btn-xs-r', translate: true,
            func: () => this.state.go('vtlink-test', { vt_keyno: this.page?.vt_keyno, vtlink_keyno: '0' }),
            disabled: () => Number(this.page?.vt_keyno ?? 0) > 0 ? false : 'hidden',
        }]);
    }

    private configureMainGrid(): void {
        this.grid = new Grid()
            .setRememberId('w_vts_vt_grid')
            .setLoadDataFunction({ method: 3786, parameters: {} })
            .setKendoConfig({ height: null, sortable: true, aggregate: true, pager: false, pageable: false, selectable: false, filterable: false })
            .setCustomToolbarButtons([
                { name: 'vts_new', text: 'vts_new', icon: 'fa-plus', cssClass: 'btn btn-primary im-grid-btn-xs-r', translate: true, func: () => this.state.go('vt-test', { vt_keyno: '0' }) },
                { name: 'import_from_disc', text: 'import_from_disc', icon: 'fa-plus', cssClass: 'btn btn-primary im-grid-btn-xs-r', translate: true, func: () => this.importVtFromDisc(), disabled: () => (this.page?.dev ?? '0') > '0' ? false : 'hidden' },
            ])
            .setOptionFunc((event: { data?: { clickedCell?: { dataItem?: { vt_keyno?: string } } } }) => this.selectVt(event));
    }

    public async ngOnInit(): Promise<void> {
        this.page = (await this.service.getSetting())[0];
        this.configureMainGrid();
        this.configureChildGrids();
    }
}
